export default "__VITE_ASSET__DDD_69Gr__"